import React, { ReactElement, useEffect } from 'react';
import { Content } from './Content';
import { useUILogic } from '../../shared/providers/UILogicProvider/hooks';

interface InvitationPageProps {
  invitationToken?: string;
  email?: string;
}

function InvitationPage({ invitationToken, email }: InvitationPageProps): ReactElement {
  const { authorizationUiModule } = useUILogic();

  useEffect(() => {
    if (!invitationToken) {
      authorizationUiModule.module.openLoginPage();
    }
  }, [invitationToken, authorizationUiModule]);

  if (!invitationToken) {
    return <></>;
  }

  return <Content invitationToken={invitationToken} email={email} />;
}

export { InvitationPage };
